module.exports = __webpack_public_path__ + "img/approvers.aa328c20.svg";